import { Module } from "@webmotors/ioc";
import { ConsoleService } from "./services/console.service";

export const LoggerModule: Module = {
  name: "LoggerModule",
  providers: [ConsoleService],
};
